import { isArray, isNumber, isObject, isString, resolveFirst } from "@churchofjesuschrist/maps-utils";
export default class Size {
  static create(width, height) {
    return Size.toJSON({
      width,
      height
    });
  }
  static toJSON(size) {
    let width = null,
      height = null;
    if (isArray(size)) {
      [width, height] = size;
    } else if (isObject(size)) {
      width = resolveFirst(size, "width", "x", "w");
      height = resolveFirst(size, "height", "y", "h");
    } else if (isString(size)) {
      let parts = size.split(/\s*[,x\s]\s*/gi);
      if (parts.length >= 2) {
        width = parseInt(parts[0]);
        height = parseInt(parts[1]);
      }
    }
    if (isNumber(width) && isNumber(height)) {
      return {
        width: Math.ceil(width),
        height: Math.ceil(height)
      };
    }
    return null;
  }
  static serialize(size) {
    let json = Size.toJSON(size);
    if (json) {
      return [json.width, json.height];
    }
    return null;
  }
}